import { useMemo } from "react";
import { Permissions } from "../../app/constants/permissions";
import { useAuth } from "../../app/auth/useAuth";
import { useChannelAvailability } from "../../app/integrations/useChannelAvailability";
import { useI18n } from "../../app/i18n/useI18n";
import { NavCardGrid,type NavCardGroup } from "../../components/NavCardGrid";
import { filterSettingsItems,settingsCatalogGroups,settingsGroupCapabilityEnabled } from "./settingsCatalog";

export function SettingsHomePage() {
  const auth = useAuth();
  const channelAvailability = useChannelAvailability();
  const { text } = useI18n();

  const groups = useMemo((): NavCardGroup[] => {
    const rawCaps = auth.info?.capabilities;
    const isOwnerOrAdmin = auth.hasRole("admin") || auth.hasPermission(Permissions.BillingWrite);
    const ctx = {
      capabilities: rawCaps,
      role: auth.info?.role || "",
      isOwnerOrAdmin,
      hasAnyPermission: (...permissions: string[]) => auth.hasAnyPermission(...permissions),
      channels: channelAvailability.canSend
    };
    return settingsCatalogGroups
      // Eine Gruppe erscheint, sobald eine ihrer Seiten erlaubt ist; es gibt kein Basisrecht „Einstellungen“.
      .filter((g) => isOwnerOrAdmin || settingsGroupCapabilityEnabled(g.key, auth.info))
      .map((g) => ({
        titleKey: g.titleKey,
        items: filterSettingsItems(g.items, ctx).map((item) => ({
          titleKey: item.titleKey,
          descriptionKey: item.descriptionKey,
          iconKey: item.iconKey,
          path: item.path,
          capabilityKey: item.capabilityKey
        }))
      }))
      .filter((g) => (g.items || []).length > 0);
  }, [auth, channelAvailability.canSend]);

  return (
    <NavCardGrid title={text("Settings")} groups={groups} text={text} />
  );
}
